import { API_METHODS, createApiFunction } from '../../api/apiProvider'

export const PRICING_ITEMS_ENDPOINT = 'v2/pricing-items'
export const DISCOUNTS_ENDPOINT = 'v2/discounts'
export const getPricingItems = ({ productType, pricingCountry, variantsIds }) =>
  createApiFunction(API_METHODS.GET, PRICING_ITEMS_ENDPOINT, {
    productType,
    pricingCountry,
    variantsIds,
  })
export const getDiscounts = ({
  productType,
  pricingCountry,
  variantsIds,
  promocode,
}) =>
  createApiFunction(API_METHODS.GET, DISCOUNTS_ENDPOINT, {
    productType,
    pricingCountry,
    variantsIds,
    promocode,
  })
export const calculateCheckoutSummary = ({
  productType,
  pricingCountry,
  variantsIds,
  promocode,
  giftCodes,
  products,
  address,
  discountId,
  checkoutId,
  timestamp,
  curExecutionId,
}) => {
  return createApiFunction(
    API_METHODS.POST,
    'checkout-summary',
    {
      productType,
      pricingCountry,
      variantsIds,
      promocode,
      giftCodes,
      products,
      address,
      discountId,
      checkoutId,
      timestamp,
      curExecutionId,
    },
    false
  )
}

/**
 * @param {{
 *   orders: unknown[]
 *   pricingCountry?: string
 *   checkoutId?: string
 *   timestamp?: number
 *   address?: unknown
 *   promocode?: string | null
 *   giftCodes?: string[]
 *   curExecutionId?: string
 * }} params
 */
export const calculateGroupCheckoutSummary = ({
  orders,
  pricingCountry,
  checkoutId,
  timestamp,
  address,
  promocode,
  giftCodes,
  curExecutionId,
}) => {
  return createApiFunction(
    API_METHODS.POST,
    'checkout-summary/group',
    {
      orders,
      pricingCountry,
      checkoutId,
      timestamp,
      address,
      promocode,
      giftCodes,
      curExecutionId,
    },
    false
  )
}

export const calculateBatchProductsPricing = ({
  productsCollections,
  productType,
  pricingCountry,
  variantsIds,
  promocode,
}) => {
  return createApiFunction(API_METHODS.POST, 'checkout-summary/batch-pricing', {
    productsCollections,
    productType,
    pricingCountry,
    variantsIds,
    promocode,
    ignoreFreeTiles: true,
  })
}
